import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
export function AdminNotFoundPage() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="管理页面不存在"
      subTitle="相关平台能力可能尚未进入当前交付轮次。"
      extra={
        <Button type="primary" onClick={() => navigate("/tenants")}>
          返回企业中心
        </Button>
      }
    />
  );
}
